
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoshirdiinovacrystacabs() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Innova Crysta Cabs',
        heading: 'Meghana Cab : Pune to Shirdi Innova Crysta Cabs',
        headingDescription: 'Meghana Cab offers Pune to Shirdi Innova Crysta Cabs, providing a luxurious, safe, and peaceful travel experience for devotees and travelers visiting the sacred Sai Baba temple town. Our Innova Crysta vehicles are perfect for families and groups, featuring plush leather seats, spacious interiors, ample legroom, and generous luggage space to ensure comfort throughout the journey.',


        top: 'Top Places to Visit in Shirdi with Meghana Cab',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The spiritual heart of Shirdi, the Sai Baba Samadhi Mandir houses the marble tomb of Shri Sai Baba, a saint revered by millions. Built in 1922, the temple attracts devotees from across India and the world who come for darshan and blessings. Inside the sanctum stands a life-size marble idol of Sai Baba in a seated posture. The temple premises are well-managed with multiple aartis held throughout the day, including Kakad, Madhyan, Dhoop, and Shej Aarti. Pilgrims often spend hours immersed in devotion within its peaceful premises."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Located adjacent to the Samadhi Mandir, Dwarkamai is a humble mosque where Sai Baba spent a significant portion of his life. Inside, one can still find the sacred fire (dhuni) lit by Baba, which continues to burn even today. Devotees collect vibhuti (sacred ash) from the dhuni as prasad. The mosque also displays Baba’s stone seat, the grinding stone he used, and the oil lamps he once lit—each artifact soaked in spiritual significance and historic memory."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a small yet sacred building where Sai Baba used to sleep every alternate night during his later years. Today, it holds his wooden bed, water pot, and ceremonial items. On Thursdays, a grand palkhi procession is carried out, where a photograph of Sai Baba and his personal belongings are paraded through the streets with devotional songs and chants. The atmosphere is filled with energy and faith, making it a deeply moving experience for all who attend."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan marks the spot where Sai Baba was first seen meditating under a neem tree at the age of sixteen. Today, a marble statue of Sai Baba is installed alongside a shivling and a sacred fire lamp that burns continuously. Devotees believe lighting incense sticks here grants wishes and cures ailments. This quiet, spiritually charged place is ideal for meditation and connecting with the origins of Baba’s journey."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a beautifully designed theme park and open-air museum that depicts important events from Sai Baba’s life through lifelike statues, rural dioramas, and village scenes. It offers visitors a chance to understand Baba’s teachings in a visual, engaging way. The site also features rides, a food court, and lush greenery, making it a great educational and leisure spot for families and children."
  },
  {
    "title": "Khandoba Temple",
    "description": "Located at the entry of Shirdi village, this temple holds special importance as it was here that the local priest Mhalsapati first recognized Sai Baba and called him ‘Ya Sai’. Dedicated to Lord Khandoba, an incarnation of Lord Shiva, the temple has a calm and spiritual atmosphere and is usually visited before entering the main temple complex. Its historical connection to Baba’s early days in Shirdi adds to its reverence."
  },
  {
    "title": "Lendi Baug",
    "description": "A peaceful garden developed by Sai Baba himself, Lendi Baug was where he used to water plants and meditate under a neem tree. The garden houses a marble Nanda Deep (eternal lamp) placed by Baba, which is still kept burning. There’s also a small well and meditation zone. It’s an ideal place for morning walks, quiet reflection, and feeling connected to Baba’s daily routine and love for nature."
  },
  {
    "title": "Shri Saibaba Sansthan Prasadalaya",
    "description": "Managed by the Shri Saibaba Sansthan Trust, this prasadalaya serves clean, hygienic, and affordable vegetarian meals to thousands of devotees daily. The massive dining halls, systematic service, and spiritual energy make it more than just a canteen—it’s an embodiment of Baba’s message of equality and selfless service. Visitors often consider it a blessing to partake in this community meal."
  },
  {
    "title": "Sai Teerth Theme Park",
    "description": "India’s first spiritual theme park, Sai Teerth by Malpani Group offers a 5D experience of Sai Baba’s life through immersive shows, animatronics, and high-end visuals. It includes attractions like 'Sabka Malik Ek', a 5D film, 'Dwarkamai – Live Show', 'Teerth Yatra' with replicas of 10 sacred pilgrim sites, and 'Lanka Dahan' – a dramatic Hanuman-themed show. It’s a modern take on spiritual storytelling, ideal for families and youth."
  },
  {
    "title": "Wet n Joy Water Park (Near Shirdi)",
    "description": "Just a few kilometers from the main temple, Wet n Joy is a large water park with slides, wave pools, lazy rivers, and rain dance setups. It’s the perfect place for a fun break after spiritual darshan, especially for families traveling with kids. The park maintains good safety standards and provides food and locker facilities, making it a full-day recreation option for those staying in Shirdi overnight."
  }
],

   "services": [
    {
      "name": "Pune to Shirdi Innova Crysta Cab Booking",
      "description": "Experience a smooth and sacred journey with our Pune to Shirdi Innova Crysta cab booking service. Designed for comfort and convenience, our premium SUVs are perfect for pilgrims, families, and spiritual travelers visiting the Sai Baba Temple. Enjoy flexible departure times, professional chauffeurs, and a well-maintained vehicle that makes the 200+ km drive from Pune to Shirdi peaceful and hassle-free."
    },
    {
      "name": "One Way Innova Crysta Pune Shirdi",
      "description": "Need a one-way drop to Shirdi? Our one-way Innova Crysta service from Pune is ideal for travelers looking for a cost-effective and luxurious transfer. Avoid the stress of return bookings and enjoy a direct ride to Shirdi with spacious seating, AC comfort, and luggage space for all your travel needs."
    },
    {
      "name": "Round Trip Innova Crysta Pune Shirdi",
      "description": "Choose our round-trip Innova Crysta cab from Pune to Shirdi for ultimate flexibility and comfort. Whether you're planning a day trip or staying overnight, our service includes a courteous driver, timely pick-up and drop, and full-day vehicle availability for temple visits or local sightseeing in Shirdi."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Shirdi",
      "description": "Travel in total comfort with our air-conditioned Innova Crysta taxis on the Pune to Shirdi route. With plush interiors, dual-zone climate control, and smooth suspension, this ride ensures a pleasant journey across varying terrains, whether you’re heading to a religious ceremony or a quiet weekend retreat."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Shirdi",
      "description": "Enjoy a worry-free ride with our chauffeur-driven Innova Crysta from Pune to Shirdi. Our trained and polite drivers ensure your safety, punctuality, and a pleasant travel experience. They’re familiar with the best routes, road conditions, and stopovers—making your journey smooth and timely."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Shirdi",
      "description": "Our private Innova Crysta taxi service between Pune and Shirdi guarantees exclusivity and comfort. No ride sharing, no detours—just a personalized, direct trip for you and your group. This is ideal for family visits, spiritual trips, or corporate travel with a touch of class."
    },
    {
      "name": "Online Booking Innova Crysta Cab Pune Shirdi",
      "description": "Book your Pune to Shirdi Innova Crysta cab online with ease through our user-friendly platform. Get instant confirmation, transparent pricing, and secure payment options. Our online booking system ensures convenience, allowing you to plan your trip with just a few clicks."
    },
    {
      "name": "Family Innova Crysta Trip Pune Shirdi",
      "description": "Make your family pilgrimage to Shirdi comfortable and memorable with our 6/7-seater Innova Crysta. With ample space for passengers and luggage, child-friendly features, AC, and reclining seats, it’s the ideal vehicle for family travel to the sacred town of Shirdi."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Innova Crysta Cab Booking", "One Way Innova Crysta Pune Shirdi"],
    ["Round Trip Innova Crysta Pune Shirdi", "AC Innova Crysta Taxi Pune Shirdi"],
    ["Chauffeur Driven Innova Crysta Pune Shirdi", "Private Innova Crysta Taxi Pune Shirdi"],
    ["Online Booking Innova Crysta Cab Pune Shirdi", "Family Innova Crysta Trip Pune Shirdi"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Cabs from Pune to Shirdi",
    "WhyChoosedescription": "Travel from Pune to the holy town of Shirdi in comfort and peace with our Innova Crysta cab service. Whether you're heading for a spiritual visit to Shri Sai Baba Temple or a family pilgrimage, we ensure a relaxed, reliable, and premium travel experience."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Pilgrimage Travel",
    "WhyChoosedescription": "Innova Crysta offers ample space for up to 6–7 passengers, making it ideal for families or small groups. Enjoy reclining seats, strong AC, smooth suspension, and enough luggage room for an easy journey over the 190+ km route."
  },
  {
    "WhyChooseheading": "Experienced Drivers for a Safe and Peaceful Journey",
    "WhyChoosedescription": "Our drivers are polite, punctual, and experienced with the Pune–Shirdi highway route. They prioritize safe driving, timely arrivals, and can assist with local knowledge to ensure a hassle-free darshan experience."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Cabs",
    "WhyChoosedescription": "All Innova Crysta vehicles undergo regular maintenance and full sanitization before every trip. We ensure a hygienic, fresh, and comfortable ride from door to temple and back."
  },
  {
    "WhyChooseheading": "Flexible Booking – One-Way, Round Trip, or Same-Day Return",
    "WhyChoosedescription": "Choose a trip plan that fits your needs: one-way, same-day return, or overnight stay. We provide custom pickup and drop locations across Pune including Hinjewadi, Viman Nagar, Kothrud, Hadapsar, and more."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear, all-inclusive pricing that covers fuel, tolls, driver allowance, and taxes. No surprises—just reliable service and excellent value for a comfortable pilgrimage journey."
  },
  {
    "WhyChooseheading": "Perfect for Spiritual Trips and Elderly-Friendly Travel",
    "WhyChoosedescription": "The smooth ride and easy accessibility of Innova Crysta make it ideal for elderly travelers, spiritual groups, and families with children—offering a peaceful and respectful journey to Shirdi."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support for Last-Minute Plans",
    "WhyChoosedescription": "Book your Pune to Shirdi cab anytime via our website or customer helpline. Our team is available 24/7 to assist with emergency bookings, itinerary changes, or special travel requests."
  }
]






















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab from Pune to Shirdi?",
        answer: "Booking is easy—just call Meghana Cab at +91 9075462128 or visit our website for instant cab reservations."
    },
    {
        question: "What is the distance and travel time from Pune to Shirdi?",
        answer: "The distance from Pune to Shirdi is approximately 200 km, and the travel time is around 4 to 5 hours depending on traffic and road conditions."
    },
    {
        question: "Is Innova Crysta suitable for the Pune to Shirdi journey?",
        answer: "Yes, the Innova Crysta is ideal for this route, offering a comfortable and spacious ride for long-distance travel."
    },
    {
        question: "Can I book a one-way or round-trip cab to Shirdi?",
        answer: "Yes, both one-way and round-trip options are available for Pune to Shirdi cab bookings."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The Innova Crysta seats 6 to 7 passengers comfortably, with ample space for luggage."
    },
    {
        question: "Is the cab sanitized before every journey?",
        answer: "Absolutely. We sanitize all vehicles thoroughly before each trip for your health and safety."
    },
    {
        question: "Are Meghana Cab drivers experienced in this route?",
        answer: "Yes, our drivers frequently travel to Shirdi and are well-versed with the route and stops along the way."
    },
    {
        question: "What’s included in the fare for Pune to Shirdi cab service?",
        answer: "Our fare includes driver charges, fuel, and tolls. Parking or extended waiting charges may be additional."
    },
    {
        question: "Can I make stops at other places on the way to Shirdi?",
        answer: "Yes, additional stops can be arranged. Please mention them while booking to plan the trip accordingly."
    },
    {
        question: "What are the payment options for this service?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Manoj Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta from Pune to Shirdi for a family trip. Excellent service, very smooth and comfortable ride.”',
    },
    {
        name: 'Ms. Aishwarya Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Perfect cab for Shirdi darshan. The vehicle was clean, driver was courteous, and we had a peaceful journey.”',
    },
];






















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneToShirdiInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Shirdi Innova Crysta Cabs",
  "description": "Book chauffeur-driven Innova Crysta cabs from Pune to Shirdi for one way, round trip, family trips, and private taxi services. Comfortable AC rides with online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-shirdi-innova-crysta-cabs"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Shirdi Innova Crysta Cabs | Comfortable Taxi Service</title>
  <meta
    name="description"
    content="Book Innova Crysta cabs from Pune to Shirdi for one way, round trip, and family travel. AC, private, and chauffeur-driven taxi service with online booking."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Innova Crysta Cab Booking, One Way Innova Crysta Pune Shirdi, Round Trip Innova Crysta Pune Shirdi, AC Innova Crysta Taxi Pune Shirdi, Chauffeur Driven Innova Crysta Pune Shirdi, Private Innova Crysta Taxi Pune Shirdi, Online Booking Innova Crysta Cab Pune Shirdi, Family Innova Crysta Trip Pune Shirdi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToShirdiInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdiinovacrystacabs;